<template>
  <div class="container">
    <h2 class="section-title mb-2 h1">PROFIL</h2>
    <p class="text-center text-muted h5">KOMISI</p>
    <div v-if="loading">Memuat produk...</div>
    <div v-else-if="error">{{ error }}</div>
    <div v-else class="table-responsive">
      <input v-model="searchQuery" placeholder="Search..." />
      <table
        class="table table-striped table-bordered first"
        v-if="!loading && !error"
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedItems" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.description }}</td>

            <td>
              <button @click="editItem(item)" class="btn btn-default">
                Edit
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Aksi</th>
          </tr>
        </tfoot>
      </table>
      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1">
          Previous
        </button>
        <button v-for="page in totalPages" :key="page" @click="setPage(page)">
          {{ page }}
        </button>
        <button @click="nextPage" :disabled="currentPage === totalPages">
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      items: [],
      searchQuery: "",
      currentPage: 1,
      perPage: 10,
      showEditForm: false,
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(
        (item) =>
          item.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          item.description
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
      );
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.perPage);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await axios.get("https://dummyjson.com/products", {});
        this.items = response.data.products;
      } catch (error) {
        console.error("Axios error:", error); // Log error untuk debugging
        if (error.response) {
          // Kesalahan dari respons server (status code bukan 2xx)
          this.error = `Error: ${error.response.status} - ${
            error.response.data.message || "Something went wrong"
          }`;
        } else if (error.request) {
          // Tidak ada respons dari server
          this.error = "No response received from server.";
        } else {
          // Kesalahan lain
          this.error = `Error: ${error.message}`;
        }
      } finally {
        this.loading = false;
      }
    },

    setPage(page) {
      this.currentPage = page;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
  },
};
</script>

<style scoped>
.section-title {
  text-align: center;
  color: #007b5e;
  margin-bottom: 50px;
  text-transform: uppercase;
}
input {
  margin-bottom: 10px;
  padding: 8px;
  width: 100%;
}

.pagination {
  margin-top: 10px;
}

/* button {
    margin: 0 2px;
    padding: 8px;
    cursor: pointer;
  } */
button {
  margin-right: 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.edit-form {
  margin-top: 20px;
}

.edit-form input {
  margin-bottom: 10px;
  padding: 8px;
  width: 100%;
}

.edit-form button {
  padding: 8px 12px;
  cursor: pointer;
}
</style>
